import Navigation from "../Navigation/Navigation";

const AppBar = () => {
  return <Navigation />;
};

export default AppBar;
